import axios from "axios";
import baseURL from "../configs/api";

export const getEmailTemplateTypes = (tenantId: string) => {
    return getFetch(`emailTemplateType`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}